import { TextDocumentIcon } from "@fluentui/react-icons-mdl2";

import {
  TariffContainer,
  TariffContent,
  TariffName
} from "../tariffItem/style";

interface InvoiceResumeProps {
  selected?: boolean;
  onClick?: () => void;
}

export default function InvoiceResume({
  selected,
  onClick
}: InvoiceResumeProps) {
  return (
    <TariffContainer selected={selected} onClick={onClick}>
      <TariffContent>
        <TextDocumentIcon />
        <TariffName>Fatura Resumida</TariffName>
      </TariffContent>
    </TariffContainer>
  );
}
